import { render } from "./preloadErrorComponent.vue?vue&type=template&id=24e26a94"
import script from "./preloadErrorComponent.vue?vue&type=script&lang=js"
export * from "./preloadErrorComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__